<template>
	<section class="Sort0003">
		<el-row :gutter="0" class="SortHead">
			<router-link to="/sp/0002" class="Router__To__Destination"
				><i class="el-icon-close"></i
			></router-link>
			<el-col :span="6">
				<span class="SortSpan">ソート</span>
			</el-col>
			<el-col :span="12">
				<img
					src="../../../assets/image/logo-new.png"
					alt="logo"
					class="ElnetLogo"
				/>
			</el-col>
			<el-col :span="6"></el-col>
		</el-row>
		<el-row class="SortBody">
			<el-form ref="form">
				<el-form-item>
					<div class="Sort__Form__Label">年月日</div>
					<el-select
						v-model="SortValue1"
						placeholder=""
						@change="selectDateValue($event)"
					>
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<div class="Sort__Form__Label">見出し</div>
					<el-select
						v-model="SortValue2"
						placeholder=""
						@change="selectTitleValue($event)"
					>
						<el-option
							v-for="item in options2"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						></el-option>
					</el-select>
				</el-form-item>
				<div class="Sort__btn__group">
					<el-button type="info" @click="reset__Data">リセット</el-button>
					<!-- <router-link to="/sp" class="Router__To__Destination"> -->
					<el-button type="primary" class="SortBtn" @click="articleSorting"
						>OK</el-button
					>
					<!-- </router-link> -->
				</div>
			</el-form>
		</el-row>
	</section>
</template>

<script>
//import Common from '../../../common/CommonFunc.js'
import router from '../../../router';
import { mapGetters } from "vuex";
  export default  {
    name: 'Sort0003',
    props: [],
    mounted () 
    {

      /*** Change by AJ for backlog Id: 1431 */
      /*commit done for loading top page when clicking close icon*/
      this.$store.commit("sp_Situation0001/setSelectedTheme", this.getSelectedTheme);
      this.$store.commit('sp_Situation0001/setSearchConditionKey', this.getSearchConditionKey);
      this.$store.commit("sp_Situation0001/setThemeNewsCount", 0);
      this.$store.commit('sp_Situation0001/setThemeWebCount', 0);
      this.$store.commit('sp_Situation0001/setThemeMagazineCount', 0);
      this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
      this.$store.commit('sp_Situation0001/setArticleSortCount', this.getArticleSortCount);
      this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', 0);
      this.$store.commit('sp_Situation0001/setSelectedLabel', this.getSelectedLabel);
      this.$store.commit("sp_Situation0001/setNewsWebCheck", this.$route.query.newsWebCheck);
      this.$store.commit("sp_Situation0001/setActiveTabs", this.$route.query.ActiveTab);
      this.$store.commit("sp_Situation0001/setTabCheckFlagForSorting", this.$route.query.ActiveTab);
      /*commit done for loading top page when clicking close icon*/

      //Code for set previously selected value in date dropdown
      if(this.$route.query.DateValue == 'asc')
      {
        this.SortValue1 = "昇順";
        this.select_date_value = "昇順";
      }
      else if(this.$route.query.DateValue == 'desc')
      {
        this.SortValue1 = "降順";
        this.select_date_value = "降順";
      }
      else
      {
        this.SortValue1 = "なし";
        this.select_date_value = "なし";
      }

      //Code for set previously selected value in title dropdown
      if(this.$route.query.TitleValue == 'asc')
      {
        this.SortValue2 = "昇順";
        this.select_title_value = "昇順";
      }
      else if(this.$route.query.TitleValue == 'desc')
      {
        this.SortValue2 = "降順";
        this.select_title_value = "降順";
      }
      else
      {
        this.SortValue2 = "なし";
        this.select_title_value = "なし";
      }

      console.log(this.select_date_value);
      console.log(this.select_title_value);
    },
    data () {
      return {
        options: [
          {
            value: "なし",
            label: "なし"
          },
          {
            value: "昇順",
            label: "昇順"
          },
          {
            value: "降順",
            label: "降順"
          }
        
        ],
        SortValue1: "なし",
        options2: [
          {
            value: "なし",
            label: "なし"
          },
          {
            value: "昇順",
            label: "昇順"
          },
          {
            value: "降順",
            label: "降順"
          }
        
        ],
        SortValue2: "なし",
        select_date_value: '',
        select_title_value: ''
      }
    },
    methods: {
      reset__Data() {
        this.$LogButtonEvent("0003","Reset");
        this.$LogMethodIN("0003","reset__Data");         
        this.SortValue1 = 'なし'
        this.SortValue2 = 'なし'
        /***2021/04/23  #11116  START*/
        this.select_title_value = ''
        this.select_date_value = ''
        /***2021/04/23  #11116  END*/
        this.$LogMethodOut("0003","reset__Data");
      },

      selectDateValue($event){
        this.$LogButtonEvent("0003","selectDate");
        this.$LogMethodIN("0003","selectDateValue"); 
        // console.log($event);        
        // for(var j=0; j<this.options.length;j++){
        //     if($event == this.options[j].value){
        //       this.select_date_value = this.options[j]["value"];
        //     }
        // }
        this.select_date_value = $event;
        if(this.select_date_value != 'なし')
        {
          this.select_title_value = ''
          this.SortValue2 = 'なし'
        }
        console.log("sort date" +this.select_date_value);
        this.$LogMethodOut("0003","selectDateValue");
      },

      selectTitleValue($event){
        this.$LogButtonEvent("0003","selectTitle");
        this.$LogMethodIN("0003","selectTitleValue");         
        // for(var j=0; j<this.options2.length;j++){
        //     if($event == this.options2[j].value){
        //       this.select_title_value = this.options2[j]["value"];
        //     }
        // }
        this.select_title_value = $event;
        if(this.select_title_value != 'なし')
        {
          this.select_date_value = ''
          this.SortValue1 = 'なし'
        }
        console.log("sort title" + this.select_title_value);
        this.$LogMethodOut("0003","selectTitleValue");
      },

      articleSorting(){
        this.$LogButtonEvent("0003","SortArticle");
        this.$LogMethodIN("0003","articleSorting");         
        var sortDatevalue;
        var sortTitleValue;
        console.log(this.select_date_value);
        console.log(this.select_title_value);

        console.log(this.SortValue1);
        console.log(this.SortValue2);
        if(this.select_date_value == "昇順")
        {
          if(this.select_title_value == "昇順")
          {
            sortDatevalue = 'asc';
            sortTitleValue = 'asc';
          }
          else if(this.select_title_value == "降順")
          {
            sortDatevalue = 'asc';
            sortTitleValue = 'desc';
          }
          else
          {
            sortDatevalue = 'asc';
            sortTitleValue = '';
          }
        }
        else if(this.select_date_value == "降順")
        {
          if(this.select_title_value == "昇順")
          {
            sortDatevalue = 'desc';
            sortTitleValue = 'asc';
          }
          else if(this.select_title_value == "降順")
          {
            sortDatevalue = 'desc';
            sortTitleValue = 'desc';
          }
          else
          {
            sortDatevalue = 'desc';
            sortTitleValue = '';
          }
        }
        else
        {
          if(this.select_title_value == "昇順")
          {
            sortDatevalue = '';
            sortTitleValue = 'asc';
          }
          else if(this.select_title_value == "降順")
          {
            sortDatevalue = '';
            sortTitleValue = 'desc';
          }
          else
          {
            sortDatevalue = '';
            sortTitleValue = '';
          }
        }
        console.log(this.$route.query.ActiveTab);
        console.log(this.$route.query.newsWebCheck);
        var defaultLoading = 0;
        this.$store.commit("sp_Situation0001/setSelectedTheme", this.getSelectedTheme);
        this.$store.commit('sp_Situation0001/setSearchConditionKey', this.getSearchConditionKey);
        this.$store.commit("sp_Situation0001/setThemeNewsCount", 0);
        this.$store.commit('sp_Situation0001/setThemeWebCount', 0);
        this.$store.commit('sp_Situation0001/setThemeMagazineCount', 0);
        // 2021/07/07  #11597  START
        if((this.$route.query.ActiveTab == 'first' && this.$route.query.newsWebCheck == 1) || this.$route.query.ActiveTab == 'second')
        {
          if(this.$route.query.DateValue == 'asc' && this.select_date_value != "昇順")
          {
            this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
          }
          else if(this.$route.query.DateValue == 'desc' && this.select_date_value != "降順")
          {
            this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
          }
          else if(this.$route.query.DateValue == '' && (this.select_date_value == "昇順" || this.select_date_value == "降順"))
          {
            this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
          }
          else if(this.$route.query.TitleValue == 'asc' && this.select_title_value != "昇順")
          {
            this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
          }
          else if(this.$route.query.TitleValue == 'desc' && this.select_title_value != "降順")
          {
            this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
          }
          else if(this.$route.query.TitleValue == '' && (this.select_title_value == "昇順" || this.select_title_value == "降順"))
          {
            this.$store.commit("sp_Situation0001/setNewsFirstTabCheckboxValue", 0);
          }
        }
        // 2021/07/07  #11597  END

        if(this.$route.query.newsWebCheck == 1)
        {
          this.$store.commit("sp_Situation0001/setArticleDate", sortDatevalue);
          this.$store.commit("sp_Situation0001/setArticleTitle", sortTitleValue);
        }
        else if(this.$route.query.newsWebCheck == 5)
        {
          this.$store.commit("sp_Situation0001/setMagazineArticleDate", sortDatevalue);
          this.$store.commit("sp_Situation0001/setMagazineArticleTitle", sortTitleValue);
        }
        else
        {
          this.$store.commit("sp_Situation0001/setWebArticleDate", sortDatevalue);
          this.$store.commit("sp_Situation0001/setWebArticleTitle", sortTitleValue);
        }
        this.$store.commit("sp_Situation0001/setActiveTabs", this.$route.query.ActiveTab);
        this.$store.commit("sp_Situation0001/setTabCheckFlagForSorting", this.$route.query.ActiveTab);
        this.$store.commit("sp_Situation0001/setNewsWebCheck", this.$route.query.newsWebCheck)
        this.$store.commit('sp_Situation0001/setThemeLoadCheck', 1);
        this.$store.commit('sp_Situation0001/setArticleSortCount', this.getArticleSortCount);
        this.$store.commit('sp_Situation0001/setIsDefaultDateLoading', defaultLoading);
        this.$store.commit('sp_Situation0001/setSelectedLabel', this.getSelectedLabel)
        router.push({name:"sp_0001"});
        this.$LogMethodOut("0003","articleSorting");
      }

    },
    computed: {
      ...mapGetters("sp_Situation0001", ["getSearchConditionKey",
                                        "getSelectedTheme",
                                        "getThemeNewsCount",
                                        "getThemeWebCount",
                                        "getThemeLoadCheck",
                                        "getArticleSortCount",
                                        "getSelectedLabel"]),    
    },
  beforeCreate(){
    
      //Common.Session.SP_CheckSessionExists_IfExpired_GoToLogout();
  }
}
</script>

<style scoped>
@import "0003.css";
@import "../../../assets/css/customStyle.css";
</style>
